var a;!function(a){a[a.Sheet=0]="Sheet",a[a.Slide=1]="Slide",a[a.SmartCanvas=2]="SmartCanvas"}(a||(a={}));var e=Symbol.for("IEnvConfigFeature");export{e as I,a as P};
